<section class="faqs" id="faqs">
  <div class="faqs__inner">

    <!-- Left: heading + contact info -->
    <div class="faqs__heading">
      <div class="faqs__heading-text">
        <h2 class="h2" style="color: var(--color-primary-950);">Preguntas frecuentes</h2>
        <p class="body-m" style="color: var(--color-neutral-950);">
          Todo lo que necesitas saber antes de venir a un taller.
        </p>
        <p class="body-m" style="color: var(--color-neutral-950);">
          Si aún te quedan dudas puedes escribirnos al formulario o contactarnos por Whatsapp o redes
          sociales y te responderemos encantados.
        </p>
        <button class="btn btn-primary" (click)="scrollToContact()">Contactar</button>
      </div>

      <div class="faqs__contact-data">
        <div class="faqs__contact-item">
          <span class="label-caps" style="color: var(--color-neutral-950);">Whatsapp</span>
          <a href="tel:+34111222666" class="faqs__contact-link body-s">111 222 666</a>
        </div>
        <div class="faqs__contact-item">
          <span class="label-caps" style="color: var(--color-neutral-950);">Instagram</span>
          <a href="https://instagram.com/arumaturismo" target="_blank" rel="noopener" class="faqs__contact-link body-s">&#64;arumaturismo</a>
        </div>
      </div>
    </div>

    <!-- Right: accordion -->
    <div class="faqs__list">
      @for (faq of faqs; track faq.question; let i = $index) {
        <div class="faqs__item" [class.faqs__item--open]="openIndex() === i">
          <button class="faqs__question body-m" (click)="toggle(i)" [attr.aria-expanded]="openIndex() === i">
            <span>{{ faq.question }}</span>
            <span class="faqs__icon" aria-hidden="true">
              @if (openIndex() === i) {
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="10" cy="10" r="9.5" stroke="currentColor"/>
                  <path d="M6 10h8" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/>
                </svg>
              } @else {
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="10" cy="10" r="9.5" stroke="currentColor"/>
                  <path d="M10 6v8M6 10h8" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/>
                </svg>
              }
            </span>
          </button>
          @if (openIndex() === i) {
            <div class="faqs__answer body-s">
              @for (line of faq.answer.split('\n\n'); track $index) {
                <p>{{ line }}</p>
              }
            </div>
          }
        </div>
      }
    </div>

  </div>
</section>
